import { Card, Statistic, Typography } from 'antd'
import {
  FileTextOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  BarChartOutlined,
  ArrowUpOutlined,
} from '@ant-design/icons'

const { Title, Paragraph, Text } = Typography

export function DashboardPage() {
  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <Title level={2} style={{ marginBottom: 8 }}>
          Dashboard
        </Title>
        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          Overview of your assessments and key metrics
        </Paragraph>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: 16,
        }}
      >
        <Card>
          <Statistic
            title="Total Assessments"
            value={248}
            prefix={<FileTextOutlined />}
            suffix={
              <Text type="success" style={{ fontSize: 14 }}>
                <ArrowUpOutlined /> +12%
              </Text>
            }
          />
          <Text type="secondary" style={{ fontSize: 12 }}>
            from last month
          </Text>
        </Card>
        <Card>
          <Statistic
            title="Active"
            value={189}
            prefix={<CheckCircleOutlined />}
            valueStyle={{ color: '#52c41a' }}
            suffix={
              <Text type="success" style={{ fontSize: 14 }}>
                <ArrowUpOutlined /> +8
              </Text>
            }
          />
          <Text type="secondary" style={{ fontSize: 12 }}>
            new this week
          </Text>
        </Card>
        <Card>
          <Statistic
            title="Pending Review"
            value={42}
            prefix={<ClockCircleOutlined />}
            valueStyle={{ color: '#faad14' }}
          />
          <Text type="warning" style={{ fontSize: 12 }}>
            Needs attention
          </Text>
        </Card>
        <Card>
          <Statistic
            title="Avg Completion"
            value={87}
            prefix={<BarChartOutlined />}
            suffix="%"
            valueStyle={{ color: '#1890ff' }}
          />
          <Text type="success" style={{ fontSize: 12 }}>
            <ArrowUpOutlined /> +5% improvement
          </Text>
        </Card>
      </div>
    </div>
  )
}

